/** @module csi/card/AttributeCardRenderer */
define([
	"dojo/_base/declare",
	"dojo/when",
	"underscore",
	"csi/card/_base",
	"csi/card/AttributeCard",
	"csi/heading/PropertyName",
	"csi/html",
	"csi/xml"
], function(declare, when, _, csiCard, AttributeCard, PropertyName, html, xml) {

	return declare(PropertyName, {
		/** @property {boolean} cardAttributeLink - set to true to show link for first attribute */
		cardAttributeLink: false,

		/** @property {boolean} cardAttributeMultiline - this property is passed onto the AttributeCard widget
		 * It is used only for slim cardAttribute view: if true, then attributes will not wrap individually */
		cardAttributeMultiline: false,

		/** @property {boolean} cardAttributesOnly - set to true to only show slim card attribute values without image and tooltip */
		cardAttributesOnly: false,

		/** @property {string} cardInstanceType - type of node whose card to display (if path to instance always leads to same type; if not, an additional query parameter can be used) */
		cardInstanceType: "",

		/** @property {string} cardPathToInstance - path id storing reference to root node of card, if not the same as the node in context */
		cardPathToInstance: "",

		/**
		 * @override
		 * Add dependency paths for attribute card if type is known
		 */
		addRendererDependencyPaths: function(h, paths) {
			if (this.cardInstanceType) {
				csiCard.getAttributeCardPaths(this.cardInstanceType, null, paths);
			}
		},

		/**
		 * @override
		 * Prevent anchor around whole card
		 */
		canLink: function() {
			return false;
		},

		/**
		 * Extension point to add parameters for AttributeCard widget per instance, such as anchorHref or anchorText
		 * @param {Context} ctx
		 * @param {Object} params 
		 */
		onAttributeCardParams: function(ctx, params) { },

		/**
		 * Extension point to add parameters for AttributeCard when rendered in tooltip
		 * @param {Context} ctx
		 * @param {Object} params 
		 */
		onTooltipAttributeCardParams: function(ctx, params) { },

		/**
		 * @override
		 * Render slim attribute card for current context with configured parameters
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const node = ctx.getNode();
			const path = this.cardPathToInstance;
			const instance = ctx.cache.getPathNode(node, path);
			const type = instance ? instance.$Type : null;
			const params = {
				ctx: ctx,
				hideImage: this.cardAttributesOnly,
				multiline: this.cardAttributeMultiline,
				pathToInstance: path,
				slim: true,
				slimLink: this.cardAttributeLink
			};

			if (type) {
				_.extend(params, csiCard.getAttributeCardSpecs(type));
			}

			this.onAttributeCardParams(ctx, params);

			new AttributeCard(params).placeAt(refNode);
			return true;
		},

		/**
		 * @override
		 * Render detailed attribute card in tooltip for instance along path after querying for necessary data
		 */
		toTooltip: function(ctx, h, tooltip) {
			const self = this;

			if (this.cardAttributesOnly) {
				return;
			}

			if (ctx.push(this.cardPathToInstance)) {
				return when(csiCard.getAttributeCardDependencies(ctx), function() {
					const div = html.create("div");
					const params = {
						ctx: ctx,
						isTooltip: true
					};

					_.extend(params, csiCard.getAttributeCardSpecs(ctx.getNodeType()));

					self.onTooltipAttributeCardParams(ctx, params);

					new AttributeCard(params).placeAt(div);

					tooltip.setContent(div);
					ctx.pop();
				});
			}
		},

		/**
		 * @override
		 * Return custom CSS for attribute cards
		 */
		_getCSS: function(type, format) {
			return "csi-attribute-card-renderer";
		}
	});
});